import { render } from "./LoginIOSView.vue?vue&type=template&id=5ece4852"
import script from "./LoginIOSView.vue?vue&type=script&lang=js"
export * from "./LoginIOSView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__